import { IconName, getDisableClickAwayProps } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { openReservation, trackAppNavbarEvent } from '../actions';
import createConnectedButton from '../utils/createConnectedButton';
import { NEW_RESERVATION_SCREEN_SHORTCUT } from '../../shortcuts';
import { getReservationUrl } from '../../../router/selectors';
import { closeAppSidebar } from '../../appSidebar';
import { NEW_RESERVATION_BUTTON_DATA_TEST_ID } from '../../newReservation/constants';

export default createConnectedButton({
    propSelectors: {
        url: getReservationUrl,
    },
    actions: (dispatch: $TSFixMe) => ({
        onClick: () => {
            dispatch(trackAppNavbarEvent('/commander/reservation/create'));
            dispatch(openReservation());
            dispatch(closeAppSidebar());
        },
    }),
    defaultProps: {
        icon: IconName.Add,
        title: TextKey.Reservation,
        shortcut: NEW_RESERVATION_SCREEN_SHORTCUT,
        ...getDisableClickAwayProps(),
        'data-test-id': NEW_RESERVATION_BUTTON_DATA_TEST_ID,
    },
});
